<template>
  <div class="worldcup">
    <div class="cup">
      <header :style="{backgroundImage:`url(${config.h5Banner})`}">
        <div class="theme">
          <div class="div">
            <img class="img" :src="`../../static/images/${isDirection?'right':'left'}.png`" alt/>
            <div>
              <p v-html="$t('300194')"></p>
            </div>
            <img :src="`../../static/images/${isDirection?'left':'right'}.png`" alt/>
          </div>
          <div class="text">
            <img :src="`../../static/images/${language}.png`" alt/>
          </div>
          <div class="time">
            <div>
              <p>{{ $t('300142') }}:2022/11/20 00:00 - 2022/12/18 23:00</p>
            </div>
          </div>
          <div class="rule" @click="$router.push('/worldcuprule')">{{ $t('300126') }}</div>
        </div>
      </header>
      <main>
        <div class="match">
          <div class="groupmacth">
            <div class="tabheader">
              <div @click="changeTab('group')" :class="{tabactive:activeind=='group'}">
                <span>{{ $t('300197') }}</span>
              </div>
              <div @click="changeTab('knockout')" :class="{tabactive:activeind=='knockout'}">
                <span>{{ $t('300201') }}</span>
              </div>
            </div>
            <div v-if="activeind=='group'" class="teams">
              <div>
                <van-tabs @click="tabchange(activename)" line-height="0" v-model="activename">
                  <van-tab v-for="(item,index) in groupnameList" :name="item" :title="$t('300198',{num:item})"
                           :key="index"></van-tab>
                </van-tabs>
              </div>
              <div v-if="groupmsg[active]" class="teamslist">
                <dl v-for="(item,index) in groupList[activename]" :key="index">
                  <dt :class="[groupmsg[active].gameStatus != 2?'light':'dark']">
                    <img :src="item.icon" alt/>
                    <div class="reward">
                      <p>{{ item[language] }}</p>
                      <p>{{ $t("300199", {num: parseInt(groupmsg[active].teams[index].amount)}) }}</p>
                    </div>
                    <div v-if="groupmsg[active].teams[index].isWinner" class="Promotion">
                      <span>{{ $t('300202') }}</span>
                    </div>
                  </dt>
                  <dd :class="[groupmsg[active].gameStatus != 2?'light':'dark']"
                      @click="support(groupmsg[active].gameStatus,groupmsg[active].teams[index].teamId)"
                      :style="{backgroundImage:`url('../../static/images/${groupmsg[active].gameStatus != 2 ?'btn_light':'btn_dark'}.png')`}">
                    <span>{{ $t('300200') }}</span>
                  </dd>
                </dl>
              </div>
              <div v-if="groupmsg[active].startTime < new Date()">
                <div v-if="!isStart" class="time">
                  <div>
                    <dl>
                      <dt>{{ $t('300212') }}</dt>
                      <dd>00</dd>
                    </dl>
                    <span>:</span>
                    <dl>
                      <dt>{{ $t('300213') }}</dt>
                      <dd>00</dd>
                    </dl>
                    <span>:</span>
                    <dl>
                      <dt>{{ $t('300214') }}</dt>
                      <dd>00</dd>
                    </dl>
                    <span>:</span>
                    <dl>
                      <dt>{{ $t('300215') }}</dt>
                      <dd>00</dd>
                    </dl>
                  </div>
                  <p>{{ $t('300203') }}</p>
                </div>
                <div v-else class="time">
                  <div>
                    <dl>
                      <dt>{{ $t('300212') }}</dt>
                      <dd>{{ time.day }}</dd>
                    </dl>
                    <span>:</span>
                    <dl>
                      <dt>{{ $t('300213') }}</dt>
                      <dd>{{ time.hours }}</dd>
                    </dl>
                    <span>:</span>
                    <dl>
                      <dt>{{ $t('300214') }}</dt>
                      <dd>{{ time.minutes }}</dd>
                    </dl>
                    <span>:</span>
                    <dl>
                      <dt>{{ $t('300215') }}</dt>
                      <dd>{{ time.second }}</dd>
                    </dl>
                  </div>
                  <p>{{ $t('300203') }}</p>
                </div>
              </div>
            </div>
            <div v-else class="knockout">
              <div>
                <van-tabs @click="changeType" line-height="0" v-model="knockoutActive">
                  <van-tab v-for="(item,index) in optionList" :name="item.value" :title="$t(item.label)"
                           :key="index+'A'"></van-tab>
                  <van-tab name="" title=""></van-tab>
                </van-tabs>
              </div>
              <div class="knockout-container" v-if="eliminList.length > 0">
                <div v-if="activeObj" class="flex-between">
                  <div class="left-icon">
                    <span class="block icon"><img :src="teamIconFilter(activeObj.teams[0].teamId)" alt=""></span>
                  </div>
                  <div class="flex-between team-name">
                    <span class="bold">{{ teamsListFilter(activeObj.teams[0].teamId) }}</span>
                    <span class="bold">{{ teamsListFilter(activeObj.teams[1].teamId) }}</span>
                  </div>
                  <div class="right-icon">
                    <span class="block icon"><img :src="teamIconFilter(activeObj.teams[1].teamId)" alt=""></span>
                  </div>
                </div>
                <div v-if="activeObj" class="flex-between">
                  <div class="text">
                    <span class="block bold" v-if="activeObj.gameStatus != 2">?</span>
                    <span class="block bold" v-else>{{
                        activeObj.teams[0].isWinner ? $t('300228') : $t('300229')
                      }}</span>
                  </div>
                  <div class="text">
                    <span class="block bold" v-if="activeObj.gameStatus != 2">?</span>
                    <span class="block bold" v-else>{{
                        activeObj.teams[1].isWinner ? $t('300228') : $t('300229')
                      }}</span>
                  </div>
                </div>
                <div v-if="activeObj" class="total-amount">
                  {{ $t('300230', {num: accAdd(activeObj.teams[0].amount, activeObj.teams[1].amount)}) }}
                </div>
                <div v-if="activeObj" class="flex-between">
                  <div class="buttons">
                    <span class="block bold flex-center button"
                          @click="supportCopy(activeObj,activeObj.teams[0].teamId)"
                          :class="[activeObj.gameStatus != 2?'light':'dark']"
                          :style="{backgroundImage:`url(../../static/images/${activeObj.gameStatus != 2?'btn_light':'btn_dark'}.png)` }">{{
                        $t('300200')
                      }}</span>
                    <span class="block amount">{{ activeObj.teams[0].amount }} ET</span>
                  </div>
                  <div class="buttons">
                    <span class="block bold flex-center button"
                          @click="supportCopy(activeObj,activeObj.teams[1].teamId)"
                          :class="[activeObj.gameStatus != 2?'light':'dark']"
                          :style="{backgroundImage:`url(../../static/images/${activeObj.gameStatus != 2?'btn_light':'btn_dark'}.png)` }">{{
                        $t('300200')
                      }}</span>
                    <span class="block amount">{{ activeObj.teams[1].amount }} ET</span>
                  </div>
                </div>
                <div v-if="activeObj && activeObj.startTime < new Date()">
                  <div v-if="!isStartCopy" class="time">
                    <div>
                      <dl>
                        <dt>{{ $t('300212') }}</dt>
                        <dd>00</dd>
                      </dl>
                      <span>:</span>
                      <dl>
                        <dt>{{ $t('300213') }}</dt>
                        <dd>00</dd>
                      </dl>
                      <span>:</span>
                      <dl>
                        <dt>{{ $t('300214') }}</dt>
                        <dd>00</dd>
                      </dl>
                      <span>:</span>
                      <dl>
                        <dt>{{ $t('300215') }}</dt>
                        <dd>00</dd>
                      </dl>
                    </div>
                    <p>{{ $t('300203') }}</p>
                  </div>
                  <div v-else class="time">
                    <div>
                      <dl>
                        <dt>{{ $t('300212') }}</dt>
                        <dd>{{ timeCopy.day }}</dd>
                      </dl>
                      <span>:</span>
                      <dl>
                        <dt>{{ $t('300213') }}</dt>
                        <dd>{{ timeCopy.hours }}</dd>
                      </dl>
                      <span>:</span>
                      <dl>
                        <dt>{{ $t('300214') }}</dt>
                        <dd>{{ timeCopy.minutes }}</dd>
                      </dl>
                      <span>:</span>
                      <dl>
                        <dt>{{ $t('300215') }}</dt>
                        <dd>{{ timeCopy.second }}</dd>
                      </dl>
                    </div>
                    <p>{{ $t('300203') }}</p>
                  </div>
                </div>
                <p v-if="activeObj" class="view-more" @click="teamsDialog = true">{{ $t('300231') }} ></p>
              </div>
              <van-empty :description="$t('300193')" v-else>
                <svg slot="image" class="icon empty-icon" aria-hidden="true">
                  <use xlink:href="#icon-zanwu"/>
                </svg>
              </van-empty>
            </div>
          </div>
          <div class="history">
            <header>
              <div>
                <img src="../../static/images/line.png" alt/>&nbsp;{{ $t('300196') }}&nbsp;<img
                src="../../static/images/line.png" alt/>
              </div>
            </header>
            <div v-if="historyList.length > 0" class="historylist">
              <van-list v-model="loading" :finished="finished" finished-text=" " loading-text=" " @load="onLoad">
                <ul v-for="(item,index) in historyList" :key="index">
                  <li>
                    <span>{{ $t('300207') }}</span>
                    <span>{{ parseTime(item.createTime, '{y}/{m}/{d} {h}:{i}:{s}') }}</span>
                  </li>
                  <li>
                    <span>{{ $t('300216') }}</span>
                    <span>{{ fixteams(item.type) }}</span>
                  </li>
                  <li>
                    <span>{{ $t('300208') }}</span>
                    <span>{{ teamsListFilter(item.teamId) }}</span>
                  </li>
                  <li>
                    <span>{{ $t('300209') }}</span>
                    <span>{{ item.betAmount }} ET</span>
                  </li>
                  <li>
                    <span>{{ $t('300210') }}</span>
                    <span>{{ item.winner ? item.winningAmount + ' ET' : '--' }}</span>
                  </li>
                  <li>
                    <span>{{ $t('300211') }}</span>
                    <p>{{ item.winner ? winteams(item.winner, item.name) : '--' }}</p>
                  </li>
                </ul>
              </van-list>
            </div>
            <div class="historyno" v-else>
              <van-empty :description="$t('300108')">
                <svg slot="image" class="icon empty-icon" aria-hidden="true">
                  <use xlink:href="#icon-zanwu"/>
                </svg>
              </van-empty>
            </div>
          </div>
        </div>
      </main>
      <!-- <van-Popup class="rulesdialog" :close-on-click-overlay="false" v-model="ruledialog">
        <div class="content">
          <header>
            <i
              @click="ruledialog=false"
              :class="
                    isDirection
                      ? 'iconfont icon-right'
                      : 'iconfont icon-left'
                  "
            ></i>
          </header>
          <div class="rulecontent">
            <b>{{ $t('300140') }}</b>
            <div class="rulescontent" v-html="config.content"></div>
          </div>
        </div>
      </van-Popup>-->
      <van-popup :close-on-click-overlay="false" v-model="notdata">
        <div class="notdata">
          <p>
            <i @click="notdata=false" class="iconfont icon-guanbi1"></i>
          </p>
          <div class="warning">
            <svg>
              <use xlink:href="#icon-tishi-1"/>
            </svg>
          </div>
          <div class="cannot">{{ $t('300217') }}</div>
          <van-button @click="notdata=false">{{ $t('300219') }}</van-button>
        </div>
      </van-popup>
      <van-popup :duration="0" :close-on-click-overlay="false" v-model="supportdialog">
        <div class="vote">
          <p>
            <span>{{ $t('300204') }}</span>
            <i @click="supportdialog=false" class="iconfont icon-guanbi1"></i>
          </p>
          <div class="input">
            <p>{{ $t('300220') }}</p>
            <div class="inputET">
              <input @input="numberFn(inputval)" :placeholder="$t('300205')" v-model="inputval" type="text"
                     @blur="blur"/>
              <span>ET</span>
            </div>
          </div>
          <p v-if="amount" class="mincount">{{ $t('300206', {num: config.minAmount}) }}</p>
          <p v-if="!amount && inputval*1 >user.available*1" class="price">
            {{ $t('300221') }}
            <span @click="Recharge">{{ $t('300222') }}</span>
          </p>
          <div class="btn">
            <van-button @click="supportdialog=false">{{ $t('300111') }}</van-button>
            <van-button class="activebtn" @click="Betting">{{ $t('300219') }}</van-button>
          </div>
        </div>
      </van-popup>
      <van-popup :close-on-click-overlay="false" position="bottom" :style="{ height: '70%' }" class="teams-popup" round
                 v-model="teamsDialog">
        <p class="title flex-between bold">{{ $t('300232') }} <i class="iconfont icon-guanbi1"
                                                                 @click="teamsDialog = false"></i></p>
        <ul type="none">
          <li class="item flex-between" v-for="(item,index) in eliminList" :key="index+'B'" @click="handleClick(item)">
            <img :src="teamIconFilter(item.teams[0].teamId)" alt="">
            <span class="inline-block">{{ teamsListFilter(item.teams[0].teamId) }} <em class="normal bold inline-block">VS</em> {{
                teamsListFilter(item.teams[1].teamId)
              }}</span>
            <img :src="teamIconFilter(item.teams[1].teamId)" alt="">
          </li>
        </ul>
      </van-popup>
    </div>
  </div>
</template>

<script>
import {
  setCookie,
  removeCookie,
  removeToken,
  getCookie,
  setToken
} from "../utils/auth";
import {Tab, Tabs, Popup, Button, Empty, List, Toast} from "vant";
import {getUserInfo} from "../api/user";
import {mapGetters} from "vuex";
import groupList from "../utils/json/teams.json";
import {parseTime} from "../utils/index";
import Methods from "../utils/methods";
import {
  worldcupconfig, //活动配置
  bettingList, //投注记录
  Betting, //投注
  getgroupmsg, // 小组赛信息
  knockoutConfig // 淘汰赛
} from "../api/resource";
import {getuseramount} from "../api/spot";
import fa from "../i18n/langs/fa";

export default {
  components: {
    vanTab: Tab,
    vanTabs: Tabs,
    vanPopup: Popup,
    vanButton: Button,
    vanEmpty: Empty,
    vanList: List
  },
  data() {
    return {
      isApp: "",
      language: "",
      activeind: "group",
      amount: false,
      groupnameList: [],
      groupList: groupList,
      activename: "A",
      active: 0,
      groupmsg: [],
      isflag: false,
      isStart: false, //比赛是否正在进行中
      nostart: false, //比赛是未开始
      config: {}, //活动配置
      time: {}, //时间倒计时
      ruledialog: false, //规则的弹框
      notdata: false, //没有开始的弹框
      supportdialog: false, //赛事正在进行中的弹框
      inputval: "", //投票输入框的值
      teamsId: "", //支持的队伍id
      ind: 1, //第一页
      historyList: [], //投票纪录列表
      loading: false,
      finished: false,
      total: 0,
      user: {},
      optionList: [
        {label: '300224', value: '2'},  // 1/8决赛
        {label: '300218', value: '3'},  // 1/4决赛
        {label: '300225', value: '4'},  // 半决赛
        {label: '300226', value: '5'},  // 三、四名决赛
        {label: '300227', value: '6'},  // 决赛
      ],
      knockoutActive: '2',
      eliminList: [],
      activeObj: null,
      isStartCopy: false,
      timeCopy: {},
      teamsDialog: false
    };
  },
  computed: {
    ...mapGetters(["isDirection", "token"]),
    teamsList() {
      let arr = [];
      this.groupnameList.forEach(v => {
        arr.push(this.groupList[v]);
      });
      return arr.flat();
    },
  },
  created() {
    this.resher();
    this.groupnameList = Object.keys(groupList);
    this.getgroupmsg();
    this.worldcupconfig();
    if (this.$route.query.token) {
      this.bettingList();
      this.getuseramount();
    }
    this.activename = this.$route.query.active
      ? this.$route.query.active
      : this.activename;
    this.active = this.$route.query.active
      ? this.$route.query.active.charCodeAt() - 65
      : this.active;
  },
  methods: {
    accAdd(arg1, arg2) {
      return Methods.accAdd(arg1, arg2)
    },
    teamIconFilter(id) {
      return this.teamsList.find(v => v.id == id).iconF
    },
    teamsListFilter(val, type) {
      if (type == 2) {
        if (val) {
          let arr = [];
          val.split(",").forEach(v => {
            arr.push(this.teamsList.find(m => m.id == v)[this.language]);
          });
          return arr.join(" , ");
        } else {
          return "/";
        }
      } else {
        return this.teamsList.find(v => v.id == val)[this.language];
      }
    },
    changeTab(type) {
      this.activeind = type
      this.activeObj = null
      if (type == 'group') {
        this.getgroupmsg()
      } else {
        this.getKnockoutConfig()
      }
    },
    fixNumber(value, unit) {
      return methods.fixNumber(value, unit);
    },
    winteams(winner, teams) {
      if (winner == "") return;
      let winlist = winner.split(",");
      let allteams = "";
      winlist.forEach((item, index) => {
        if (index == winlist.length - 1) {
          allteams += this.teamsListFilter(item);
          return;
        }
        allteams += this.teamsListFilter(item) + ", ";
      });
      return allteams;
    },
    fixteams(type) {
      switch (type) {
        case 1:
          return this.$t("300197");
        case 2:
          return this.$t("300224");
        case 3:
          return this.$t("300218");
        case 4:
          return this.$t("300225");
        case 5:
          return this.$t("300226");
        case 6:
          return this.$t("300227");
      }
    },
    Betting() {
      if (!this.inputval) {
        this.amount = true;
        return;
      } //投注
      if (this.isflag) {
        return;
      }
      this.isflag = true;
      Betting({
        teamId: this.teamsId,
        amount: this.inputval,
        type: this.activeind == 'group' ? 1 : this.knockoutActive
      }).then(
        res => {
          this.supportdialog = false;
          if (res.code == 200) {
            this.teamsId = "";
            bettingList({page: 1, pageSize: 5}).then(res => {
              this.total = res.data.total;
              this.historyList = res.data.items;
            });
            this.getuseramount()
            if (this.activeind == 'group') {
              this.getgroupmsg();
            } else {
              this.getKnockoutConfig()
            }
            Toast(this.$t("300223"));
            setTimeout(() => {
              this.isflag = false;
            }, 1000);
          } else {
            setTimeout(() => {
              this.isflag = false;
            }, 1000);
          }
        }).catch(() => {
        setTimeout(() => {
          this.isflag = false;
        }, 1000);
      });
    },
    parseTime(time, type) {
      return parseTime(time, type);
    },
    getname(name, id) {
      let teams = this.groupList[name].find(item => item.id == id);
      return teams[this.language];
    },
    Recharge() {
      //去充值
      this.supportdialog = false;
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appRecharge,
        {
          code: 200,
          active:
            window.location.href.toString().split("?")[0] +
            "?" +
            `active=${this.activename}`
        },
        data => {
        }
      );
    },
    getuseramount() {
      //获取用户的money
      getuseramount({symbol: "et_usdt"}).then(res => {
        if (res.code === 200) {
          this.user = res.data.find(item => item.currency == "et");
        }
      });
    },
    bettingList() {
      bettingList({page: this.ind, pageSize: 5}).then(res => {
        this.total = res.data.total;
        this.historyList = res.data.items;
      });
    },
    tabchange(group) {
      //切换
      this.active = group.charCodeAt() - 65;
      this.conutdown();
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      this.ind++;
      setTimeout(() => {
        bettingList({page: this.ind, pageSize: 5}).then(res => {
          this.historyList = this.historyList.concat(res.data.items);
        });
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.historyList.length >= this.total) {
          this.finished = true;
        }
      }, 1000);
    },
    worldcupconfig() {
      //活动配置
      worldcupconfig().then(res => {
        this.config = res.data;
      });
    },
    getgroupmsg() {
      //小组赛信息
      getgroupmsg().then(res => {
        this.groupmsg = res.data;
        this.conutdown();
      });
    },
    appLogout() {
      var _this = this;
      this.$jsBridge.callHandler(
        this.$jsBridgeCmd.appLogout,
        {code: 200},
        data => {
          _this.isLogin = false;
          removeToken();
          removeCookie("userInfo");
          _this.appLogin();
        }
      );
    },
    getUserInfo() {
      //获取用户信息
      getUserInfo().then(res => {
        if (res.code == 403 || res.code == 413) {
          this.appLogout();
          return false;
        }
        if (res.data) {
          this.userInfo = res.data;
          setCookie("userInfo", JSON.stringify(res.data));
        }
      });
    },
    resher() {
      // Toast(this.$route.query.token ? "有token-测试用" : "没有token-测试用");
      this.isApp = this.$route.query.isApp;
      var token = this.$route.query.token;
      this.$store.dispatch("setIsDirection", this.$route.query.language == "fa" ? true : false);
      setCookie("language", this.$route.query.language ? this.$route.query.language : "en");
      this.language = this.$route.query.language ? this.$route.query.language : "en";
      window.document.documentElement.setAttribute(
        "dir",
        this.isDirection ? "rtl" : "ltr"
      );
      if (this.isApp == 1) {
        this.$i18n.locale = this.language;
        if (token) {
          setToken(token);
          this.isLogin = true;
          this.getUserInfo();
        } else {
          removeToken();
          this.isLogin = false;
        }
      } else {
        this.isLogin = getCookie("token") ? true : false;
        if (this.isLogin) {
          this.getUserInfo();
        } else {
          removeToken();
        }
      }
    },
    conutdown() {
      this.isStart = this.groupmsg[this.active].startTime <= new Date() && this.groupmsg[this.active].endTime >= new Date();
      let timer = this.groupmsg[this.active].endTime - new Date();
      this.time = {
        day:
          parseInt(timer / 1000 / 60 / 60 / 24) < 10
            ? "0" + parseInt(timer / 1000 / 60 / 60 / 24)
            : parseInt(timer / 1000 / 60 / 60 / 24),
        hours:
          parseInt((timer / 1000 / 60 / 60) % 24) < 10
            ? "0" + parseInt((timer / 1000 / 60 / 60) % 24)
            : parseInt((timer / 1000 / 60 / 60) % 24),
        minutes:
          parseInt((timer / 1000 / 60) % 60) < 10
            ? "0" + parseInt((timer / 1000 / 60) % 60)
            : parseInt((timer / 1000 / 60) % 60),
        second:
          parseInt((timer / 1000) % 60) < 10
            ? "0" + parseInt((timer / 1000) % 60)
            : parseInt((timer / 1000) % 60)
      };
      this.nostart = this.groupmsg[this.active].startTime >= new Date();
    },
    blur() {
      this.amount = this.inputval < this.config.minAmount;
    },
    numberFn(p) {
      this.amount = this.inputval < this.config.minAmount;
      this.inputval = p.replace(/[^\d^\.]+/g, "").replace(/^0+(\d)/, "$1").replace(/^\./, "0.").match(/^\d*(\.?\d{0,2})/g)[0] || "";
    },
    support(status, id) {
      if (this.$route.query.token) {
        this.amount = false;
        this.teamsId = id;
        if (status == 2) {
          return false;
        }
        if (this.nostart) {
          this.notdata = true;
        } else {
          this.inputval = "";
          this.supportdialog = true;
        }
      } else {
        this.appLogin();
      }
    },
    appLogin() {
      if (this.isApp == 1) {
        this.$jsBridge.callHandler(
          this.$jsBridgeCmd.appLogin,
          {
            code: 200,
            type: "login",
            url:
              window.location.href.toString().split("?")[0] +
              "?" +
              `active=${this.activename}`
          },
          data => {
          }
        );
      } else {
        return false;
      }
    },
    changeType(name) {
      this.knockoutActive = name
      this.activeObj = null
      this.getKnockoutConfig()
    },
    // 获取淘汰赛配置信息
    getKnockoutConfig() {
      knockoutConfig({type: this.knockoutActive}).then(res => {
        if (res.data.length > 0) {
          this.activeObj = !this.activeObj ? res.data[0] : res.data.find(v => v.name == this.activeObj.name)
        }
        this.eliminList = res.data || []
      })
    },
    countDownCopy() {
      if (this.eliminList.length > 0 && this.activeObj) {
        this.isStartCopy = this.activeObj.startTime <= new Date() && this.activeObj.endTime >= new Date()
      } else {
        this.isStartCopy = false
      }
      let timer = this.eliminList.length > 0 && this.activeObj ? this.activeObj.endTime - new Date() : 0
      this.timeCopy = {
        day:
          parseInt(timer / 1000 / 60 / 60 / 24) < 10
            ? "0" + parseInt(timer / 1000 / 60 / 60 / 24)
            : parseInt(timer / 1000 / 60 / 60 / 24),
        hours:
          parseInt((timer / 1000 / 60 / 60) % 24) < 10
            ? "0" + parseInt((timer / 1000 / 60 / 60) % 24)
            : parseInt((timer / 1000 / 60 / 60) % 24),
        minutes:
          parseInt((timer / 1000 / 60) % 60) < 10
            ? "0" + parseInt((timer / 1000 / 60) % 60)
            : parseInt((timer / 1000 / 60) % 60),
        second:
          parseInt((timer / 1000) % 60) < 10
            ? "0" + parseInt((timer / 1000) % 60)
            : parseInt((timer / 1000) % 60)
      };
    },
    handleClick(item) {
      this.activeObj = item
      this.teamsDialog = false
      this.countDownCopy()
    },
    supportCopy(item, id) {
      if (this.$route.query.token) {
        if (item.gameStatus == 2) {
          return false;
        } else {
          if (item.startTime >= new Date()) {
            this.notdata = true;
          } else {
            this.amount = false;
            this.teamsId = id;
            this.inputval = "";
            this.supportdialog = true;
          }
        }
      } else {
        this.appLogin();
      }
    }
  },
  mounted() {
    setInterval(() => {
      this.conutdown();
    }, 1000);
    setInterval(() => {
      this.countDownCopy()
    }, 1000)
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";

[dir="ltr"] .worldcup {
  .rule {
    border-radius: torem(32) 0 0 torem(32);
    border-right: none;
    right: 0;
  }

  .inputET {
    span {
      right: torem(8);
    }
  }

  .teamslist {
    dl {
      &:nth-child(odd) {
        margin-right: torem(11);
      }
    }
  }

  .Promotion {
    top: 0;
    right: 0;
    border-radius: torem(32) 0 0 torem(32);
  }

  /deep/ .van-tab {
    &:nth-child(odd) {
      margin: 0 torem(4);
    }

    &:first-child {
      margin-left: 0;
    }
  }
}

[dir="rtl"] .worldcup {
  .rule {
    left: 0;
    border-radius: 0 torem(32) torem(32) 0;
    border-left: none;
  }

  .inputET {
    span {
      left: torem(8);
    }
  }

  .teamslist {
    dl {
      &:nth-child(odd) {
        margin-left: torem(11);
      }
    }
  }

  .Promotion {
    top: 0;
    left: 0;

    border-radius: 0 torem(32) torem(32) 0;
  }

  /deep/ .van-tab {
    &:nth-child(odd) {
      margin: 0 torem(4);
    }

    &:first-child {
      margin-right: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";

.worldcup {
  width: 100vw;
  height: torem(1467);
  background: url("../../static/images/bg.png") no-repeat;
  background-size: 100% 100%;

  .cup {
    position: relative;

    > header {
      height: torem(405);
      //width: 100vw;
      background-repeat: no-repeat;
      background-size: 100% 100%;

      .theme {
        display: flex;
        justify-content: center;
        position: relative;
        align-items: center;
        flex-direction: column;

        > .div {
          height: torem(28);
          width: torem(190);

          display: flex;
          margin-top: torem(20);

          > div {
            display: flex;
            justify-content: center;
            align-items: center;
            height: torem(28);
            width: torem(158);
            background: rgba(114, 178, 237, 1);

            p {
              font-size: torem(12);
              line-height: torem(14);
              text-align: center;
              color: rgba(255, 255, 255, 1);
              display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示
              overflow: hidden; //超出隐藏
              text-overflow: ellipsis; //溢出用省略号显示
              -webkit-line-clamp: 2; //超出两行隐藏
              -webkit-box-orient: vertical; // 从上到下垂直排列子元素
              em.normal {
                color: rgba(219, 255, 0, 1);
                font-size: torem(12);
              }
            }
          }

          .img {
            height: 100%;
            width: torem(16);
          }
        }

        .text {
          width: torem(228);
          margin-top: torem(6);

          img {
            width: 100%;
          }
        }

        > .time {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: torem(10);

          > div {
            > p {
              width: 100%;
              color: rgba(89, 70, 0, 1);
              background: linear-gradient(
                  90deg,
                  #d0f69c 0%,
                  #fbf290 45%,
                  #c2f7a0 100%
              );
              font-size: torem(10);
            }
          }
        }
      }
    }
  }
}

.rule {
  position: absolute;
  width: auto;
  min-width: torem(60);
  padding: torem(8) torem(8);
  top: torem(148);
  border: torem(1) solid rgba(51, 51, 51, 1);
  box-sizing: border-box;
  color: rgba(51, 51, 51, 1);
  font-size: torem(14);
  text-align: center;
  background: rgba(255, 199, 43, 1);
}

main {
  width: 100vw;
  position: absolute;
  top: torem(232);
  left: 0;
}

.groupmacth {
  width: torem(343);
  height: torem(543);
  background: url("../../static/images/border.png");
  background-size: 100% 100%;
  padding-top: torem(3);
  margin: 0 auto;

  .tabheader {
    height: torem(40);
    padding: 0 torem(2);
    display: flex;

    &:nth-child(1) {
      &:nth-child(1) {
        -webkit-clip-path: polygon(100% 0, 100% 110%, -8% 100%, 3% 0%);
      }
    }

    > div {
      width: 50%;
      text-align: center;
      line-height: torem(38);
      background: rgba(0, 0, 0, 0.2);

      span {
        display: inline-block;
        color: rgba(255, 255, 255, 0.7);
        font-size: torem(15);
        font-weight: bold;
        box-sizing: border-box;
      }
    }

    .tabactive {
      background: transparent;

      span {
        background-image: -webkit-linear-gradient(
            -25deg,
            rgba(255, 250, 132, 1),
            rgba(66, 255, 187, 1)
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        border-bottom: solid torem(2) rgba(104, 255, 176, 1);
      }
    }
  }

  .teams {
    padding: torem(24) torem(16);
    box-sizing: border-box;

    .time {
      width: 100%;
      height: torem(86);
      margin-top: torem(24);
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      > div {
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          font-size: torem(20);
          color: rgba(255, 255, 255, 0.7);
          margin: 0 torem(12);
          margin-top: torem(19);
        }

        > dl {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          dt {
            font-size: torem(12);
            color: rgba(255, 255, 255, 0.5);
            font-weight: 400;
          }

          dd {
            width: torem(36);
            height: torem(36);
            margin-top: torem(8);
            border: torem(1) solid rgba(255, 255, 255, 0.5);
            border-radius: torem(4);
            background: rgba(255, 255, 255, 0.05);
            text-align: center;
            line-height: torem(36);
            font-size: torem(20);
            font-weight: bold;
            color: #fff;
          }
        }
      }

      p {
        margin-top: torem(16);
        color: #fff;
        font-size: torem(14);
      }
    }

    .teamslist {
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;

      dl {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: torem(24);

        dt.dark {
          background: linear-gradient(
              170deg,
              rgba(232, 232, 232, 1),
              rgba(138, 138, 138, 1)
          );
        }

        dt.light {
          background: linear-gradient(
              170deg,
              rgba(255, 250, 132, 1),
              rgba(66, 255, 187, 1)
          );
        }

        dt {
          width: torem(150);
          height: torem(78);
          position: relative;
          padding: torem(1);
          clip-path: polygon(
              torem(6) 0,
              calc(100% - #{torem(6)}) 0,
              100% torem(6),
              100% calc(100% - #{torem(6)}),
              calc(100% - #{torem(6)}) 100%,
              torem(6) 100%,
              0 calc(100% - #{torem(6)}),
              0 torem(6)
          );

          img {
            width: 100%;
            height: 100%;
            clip-path: inherit;
          }

          .reward {
            height: torem(40);
            width: torem(148);
            position: absolute;
            bottom: torem(1);
            left: torem(1);
            padding: torem(10) torem(5);

            p {
              color: rgba(255, 255, 255, 1);

              &:nth-child(1) {
                font-size: torem(12);
                font-weight: 600;
              }

              &:nth-child(2) {
                font-size: torem(10);
                margin-top: torem(6);
              }
            }

            background: linear-gradient(
                to bottom,
                rgba(0, 0, 0, 0),
                rgba(0, 0, 0, 0.7)
            );
            clip-path: inherit;
          }
        }

        .dark {
          color: #666666;
        }

        dd {
          width: torem(134);
          height: torem(35);

          font-size: torem(15);
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: torem(12);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
    }
  }
}

.historyno {
  height: torem(400);
  display: flex;
  justify-content: center;
  align-items: center;
}

.history {
  width: torem(343);
  height: torem(543);
  background: url("../../static/images/border.png");
  background-size: 100% 100%;
  margin: torem(24) auto 0;
  padding-top: torem(12);
  box-sizing: border-box;

  header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: torem(40);

    > div {
      height: torem(40);

      img {
        height: torem(6);
      }

      display: flex;
      justify-content: center;
      align-items: center;
      background-image: -webkit-linear-gradient(
          -25deg,
          rgba(255, 250, 132, 1),
          rgba(66, 255, 187, 1)
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: torem(16);
      font-weight: bold;
    }
  }
}

/deep/ .van-tab {
  min-width: torem(72);
  height: torem(32);
  line-height: torem(32);
  font-size: torem(14);
  border: torem(1) solid;
  color: rgba(255, 255, 255, 0.7);
  border-image: linear-gradient(170deg, rgba(255, 250, 132, 1), rgba(66, 255, 187, 1)) 4 4;
}

/deep/ .van-tabs__nav {
  padding: torem(2);
  background: rgba(255, 255, 255, 0.1);
  height: torem(32);
  align-items: center;
}

/deep/ .van-tabs {
  height: torem(36);
}

/deep/ .van-tabs__wrap {
  height: torem(36) !important;
}

/deep/ .van-tabs__wrap {
  height: torem(36);
}

/deep/ .van-tab--active {
  border: none;
  color: #000;
  font-weight: bold;
  background: linear-gradient(
      150deg,
      rgba(255, 250, 132, 1) 1%,
      rgba(66, 255, 187, 1) 99%
  );
}

/deep/ .van-tabs__wrap {
  height: torem(32);
}

.Promotion {
  min-width: torem(56);
  padding: 0 torem(4);
  height: torem(28);
  color: #333333;
  background: linear-gradient(170deg, #fffa84 0%, #42ffbb 100%);
  font-size: torem(12);
  font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 999;
  padding: 0 torem(4);
  box-shadow: 0 torem(1) torem(2) 0 rgba(0, 0, 0, 0.2);
}

.content {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  padding-top: torem(12);

  header {
    height: torem(44);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 torem(16);
    box-sizing: border-box;
  }

  .rulecontent {
    flex: 1;
    padding: 0 torem(20);
    padding-top: torem(24);
    padding-bottom: torem(48);
    box-sizing: border-box;

    b {
      font-size: torem(20);
      color: #000;
    }
  }
}

.notdata {
  width: torem(312);
  padding: torem(24);
  border-radius: torem(4);

  p {
    text-align: end;

    i {
      font-size: torem(12);
    }
  }

  .warning {
    margin-top: torem(24);
    margin-bottom: torem(16);
    text-align: center;

    svg {
      width: torem(48);
      height: torem(48);
    }
  }

  .cannot {
    text-align: center;
    font-size: torem(16);
    font-weight: bold;
    color: #000;
    margin-bottom: torem(24);
  }

  .van-button {
    width: torem(264);
    height: torem(44);
    border-radius: torem(4);
    border: none;
    background: rgba(255, 199, 43, 1);
    font-size: torem(16);
    color: rgba(51, 51, 51, 1);
  }
}

.van-popup {
  border-radius: torem(4);
}

.vote {
  padding: torem(24);
  width: torem(312);
  box-sizing: border-box;

  > p {
    &:nth-child(1) {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: torem(24);

      span {
        font-size: torem(16);
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }

      i.iconfont {
        font-size: torem(12);
        color: rgba(51, 51, 51, 1);
      }
    }
  }

  .input {
    margin-top: torem(24);

    p {
      font-size: torem(14);
      color: rgba(102, 102, 102, 1);
      height: torem(14);
    }

    .inputET:hover {
      border-color: rgba(255, 199, 43, 1);
    }

    > .inputET {
      display: flex;
      width: torem(264);
      height: torem(42);
      border-radius: torem(4);
      position: relative;
      justify-content: space-between;
      align-items: center;

      input {
        width: 90%;
        height: 100%;
        font-size: torem(16);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        &::placeholder {
          font-size: torem(16);
          color: rgba(188, 188, 188, 1);
        }
      }

      border: torem(1) solid rgba(239, 239, 239, 1);
      margin-top: torem(8);

      span {
        position: absolute;

        top: torem(15);
        color: #000;
        font-size: torem(16);
      }

      padding: 0 torem(12);
      box-sizing: border-box;
    }
  }
}

.mincount {
  font-size: torem(14);
  margin-top: torem(8);
  color: red;
}

.price {
  font-size: torem(14);
  margin-top: torem(8);
  color: red;

  span {
    color: rgba(255, 199, 43, 1);
  }
}

.btn {
  margin-top: torem(24);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .van-button {
    width: torem(126);
    height: torem(42);
    border-radius: torem(4);
    background: rgba(234, 236, 239, 1);
    font-size: torem(16);
    color: rgba(51, 51, 51, 1);
  }

  .activebtn {
    background: rgba(255, 199, 43, 1);
  }
}

.historylist {
  margin-top: torem(12);
  padding: 0 torem(16);
  box-sizing: border-box;
  height: torem(460);
  overflow-y: scroll;

  ul {
    margin-top: torem(15);
    padding: torem(12) 0;
    border-bottom: torem(1) solid rgba(255, 255, 255, 0.05);

    li {
      height: torem(34);
      font-size: torem(14);
      color: rgba(255, 255, 255, 0.7);
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: torem(14);
      }

      &:last-child {
        p {
          max-width: torem(120);
          word-break: break-all;
          word-wrap: break-word;
          text-align: end;
          line-height: 1.2rem;
        }
      }
    }
  }
}

/deep/ .van-empty__image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: torem(60);

  svg {
    width: torem(47.42);
    height: torem(50);
  }
}

/deep/ .van-empty__description {
  font-size: torem(12);
  color: rgba(255, 255, 255, 0.7);
}

.rulesdialog {
  border-radius: 0;
}

.rulescontent {
  margin-top: torem(32);
  line-height: normal;
  font-size: torem(16);
}

.knockout {
  padding: torem(24) torem(16);
  box-sizing: border-box;

  /deep/ .van-tab {
    &:nth-child(6) {
      display: none;
    }
  }

  /deep/ .van-empty {
    margin-top: torem(100);
  }

  .knockout-container {
    div.flex-between {
      .left-icon, .right-icon {
        margin-top: torem(24);
        text-align: center;

        span.icon {
          width: torem(60);
          height: torem(60);
          padding: torem(1);
          background: linear-gradient(170deg, rgba(255, 250, 132, 1), rgba(66, 255, 187, 1));
          clip-path: polygon(torem(6) 0, calc(100% - #{torem(6)}) 0, 100% torem(6), 100% calc(100% - #{torem(6)}), calc(100% - #{torem(6)}) 100%, torem(6) 100%, 0 calc(100% - #{torem(6)}), 0 torem(6));
        }

        img {
          max-width: torem(58);
          clip-path: inherit;
        }
      }

      .team-name {
        width: torem(192);
        height: torem(60);
        background: url("../../static/images/VS.svg") no-repeat center;
        background-size: cover;
        margin-top: torem(22);
        padding: 0 torem(4);

        span {
          font-size: torem(10);
          color: #FFF;
          padding-top: torem(3);
        }
      }

      .text {
        margin-top: torem(10);
        min-width: torem(60);
        text-align: center;

        span {
          font-size: torem(14);
          color: #FFF;
        }
      }
    }

    .total-amount {
      width: 100%;
      margin: torem(24) 0 torem(16);
      text-align: center;
      font-size: torem(12);
      color: rgba(255, 255, 255, 0.7);
    }

    .buttons {
      text-align: center;

      .button {
        width: torem(134);
        height: torem(36);
        font-size: torem(15);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        justify-content: center;
      }

      .amount {
        margin-top: torem(12);
        font-size: torem(12);
        color: rgba(255, 255, 255, 0.7);
      }

      .button.dark {
        color: #666666;
      }

      .button.light {
        color: #333333;
      }
    }

    .time {
      width: 100%;
      height: torem(86);
      margin-top: torem(24);
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      > div {
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          font-size: torem(20);
          color: rgba(255, 255, 255, 0.7);
          margin: 0 torem(12);
          margin-top: torem(19);
        }

        > dl {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          dt {
            font-size: torem(12);
            color: rgba(255, 255, 255, 0.5);
            font-weight: 400;
          }

          dd {
            width: torem(36);
            height: torem(36);
            margin-top: torem(8);
            border: torem(1) solid rgba(255, 255, 255, 0.5);
            border-radius: torem(4);
            background: rgba(255, 255, 255, 0.05);
            text-align: center;
            line-height: torem(36);
            font-size: torem(20);
            font-weight: bold;
            color: #fff;
          }
        }
      }

      p {
        margin-top: torem(16);
        color: #fff;
        font-size: torem(14);
      }
    }

    .view-more {
      width: 100%;
      text-align: end;
      margin-top: torem(36);
      font-size: torem(14);
      color: #FFC72B;
    }
  }
}

.teams-popup {
  border-radius: torem(16) torem(16) torem(0) torem(0);
  padding: torem(24);
  overflow-y: auto;

  p.title {
    padding: torem(12) 0;
    font-size: torem(16);
    color: #333333;

    i {
      color: #999999;
      font-weight: normal;
    }
  }

  li.item {
    padding: torem(12) torem(11);
    border: torem(1) solid;
    border-image: linear-gradient(170deg, rgba(255, 250, 132, 1), rgba(66, 255, 187, 1)) 1 1;
    border-radius: torem(4);
    margin-top: torem(12);

    img {
      max-width: torem(32);
      border-radius: 50%;
      border: torem(1) solid #EFEFEF;
    }

    span {
      font-size: torem(14);
      color: #333333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/worldcup.vue